import clsx from 'clsx';
import { linkify } from 'core';
import { useTranslate } from 'core/hooks/useTranslate';
import { Avatar, Icon, ListSimpleDropdown, Popover, TextHtml } from 'ui';
import ItemComplexList from 'core/modules/components/general/ItemComplexList';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

const CommentItem = ({ currentUser, guid, creator_guid, user, text, createdAt, onDelete, onEdit, parentGuid, disabled }) => {
  const { t } = useTranslate();
  const [anchorEl, setAnchorEl] = useState({});
  const [openLinkDropDown, setOpenLinkDropDown] = useState(false);

  function onOpenDropdownLink(event) {
    setAnchorEl(event.currentTarget);
    setOpenLinkDropDown(true);
  }

  function handleCloseLinkDropdown() {
    setOpenLinkDropDown(false);
  }

  function onDeleteComment() {
    onDelete(guid, parentGuid);
    handleCloseLinkDropdown();
  }

  function onEditComment() {
    onEdit(guid, text, parentGuid);
    handleCloseLinkDropdown();
  }

  function imTheOwner() {
    return creator_guid === (currentUser ? currentUser.guid : null);
  }

  function isTeacher() {
    return currentUser.role_guid === 'R02';
  }

  function getAvatar() {
    if (!user.avatar && imTheOwner()) {
      return currentUser.avatar;
    } else {
      return user.avatar;
    }
  }

  function getUsername() {
    if (!user.name && imTheOwner()) {
      return currentUser.name + ' ' + currentUser.lastname;
    } else {
      return user.name + ' ' + user.lastName;
    }
  }

  function renderInfo() {
    const formattedDate = createdAt ? moment(createdAt).format('DD/MM HH:mm') : '';
    const userTitle = formattedDate ? `${getUsername()} ${formattedDate}` : getUsername();

    return (
      <div className="comment-item__info">
        <div className="comment-item__info-main">
          <span className="comment-item__user" title={userTitle}>
            {getUsername()}
          </span>
          {formattedDate && <span className="comment-item__date">{formattedDate}</span>}
        </div>

        <span className="comment-item__text"> {text && <TextHtml text={linkify(text, t)} className="post-card__text" />}</span>
      </div>
    );
  }

  return (
    <div className={clsx('comment-item', { 'comment-item--mine': imTheOwner() })}>
      <ItemComplexList
        left={<Avatar image={getAvatar()} />}
        center={renderInfo()}
        right={
          !disabled && (imTheOwner() || isTeacher()) && (
            <div className="comment-item__options" onClick={onOpenDropdownLink}>
              <Icon name="more-bullets" size="xl" />
            </div>
          )
        }
      />
      <Popover anchorEl={anchorEl} open={openLinkDropDown} handleClose={handleCloseLinkDropdown} shouldFocusOnOpen={false}>
        {onEdit && <ListSimpleDropdown items={[{ name: t('actions:Edit'), icon: 'pencil', onClick: onEditComment }]} shouldAutoFocusFirstItem />}
        <ListSimpleDropdown items={[{ name: t('actions:Delete'), icon: 'trash', onClick: onDeleteComment }]} shouldAutoFocusFirstItem={!onEdit} />
      </Popover>
    </div>
  );
};

CommentItem.propTypes = {
  createdAt: PropTypes.string,
  creator_guid: PropTypes.string,
  currentUser: PropTypes.object,
  disabled: PropTypes.bool,
  guid: PropTypes.string,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  parentGuid: PropTypes.string,
  text: PropTypes.string,
  user: PropTypes.object,
};

CommentItem.defaultProps = {
  likes: 0,
  user: {},
};

export default CommentItem;
